
const GulfStudentsResourceData = [
    {
        id: 1,
        bannerImg: require("../../../Assets/Gulf_Students/Student_Resource/Visa-travel-checklists.png"),
        text: "Visa & travel checklists"
    },
    {
        id: 2,
        bannerImg: require("../../../Assets/Gulf_Students/Student_Resource/study-templates.png"),
        text: "Academic planners & study templates"
    },
    {
        id: 3,
        bannerImg: require("../../../Assets/Gulf_Students/Student_Resource/Scholarship-tracking-sheets.png"),
        text: "Internship search strategies"
    },
    {
        id: 4,
        bannerImg: require("../../../Assets/Gulf_Students/Student_Resource/Webinar-replays.png"),
        text: "Webinar replays and PDF guides"
    }
];

export default GulfStudentsResourceData;